import type { components } from '@/types/gateway_schema'
import { useOrganizationUnitStore } from '@/stores/store_organization_unit'

/**
 * Get the path to the organization unit,
 * skips the steps if there is only
 * 1 child unit
 */
export function node_path(unit: components['schemas']['SopravisionOrganizationUnitDTO']) {
  if (unit.childrens.length === 1) {
    return `/dashboard/unit/${unit.childrens[0].id}`
  }

  return `/dashboard/unit/${unit.id}`
}

/**
 * Get the return path of an unit
 * if there is only 1 unit in the level above
 * skips to the next one
 */
export function node_return(node: ApplicationTreeNode) {
  const store = useOrganizationUnitStore()

  if (node.parent === store.getRoot?.id) {
    return `/dashboard`
  }

  const parent_node = store.getByID(node.parent!)
  if (parent_node) {
    if (parent_node.childrens.length === 1) {
      if (parent_node.parent === store.getRoot?.id) {
        return `/dashboard`
      }
      return `/dashboard/unit/${parent_node.parent}`
    }
  }

  return `/dashboard/unit/${node.id}`
}

export function is_node_empty(node: ApplicationTreeNode) {
  if (node.childrens.length === 1) {
    return is_node_empty(node.childrens[0])
  }

  const store = useOrganizationUnitStore()
  if (!node.parent) return true
  return store.getByID(node.parent)?.childrens.length == 1 || node.childrens.length == 0
}

export type ApplicationAlert = {
  title: string
  date: Date
}

export type ApplicationTreeNode = components['schemas']['SopravisionOrganizationUnitDTO']
